import { NgModule } from '@angular/core';
import { LibContinueIconComponent } from './lib-continue-icon.component';

@NgModule({
  declarations: [LibContinueIconComponent],
  exports: [LibContinueIconComponent],
})
export class LibContinueIconModule {}
